// hooks/useApi.js
import { useMemo } from 'react';

import api from './axiosInstance'; // Adjust path as needed

const useApi = () => {
    const apiWithContext = useMemo(() => {
        const injectContextForDataMethods = method => {
            return (url, data, config = {}) => {
                const finalConfig = {
                    ...config,
                };
                return method(url, data, finalConfig);
            };
        };

        const injectContextForNoDataMethods = method => {
            return (url, config = {}) => {
                const finalConfig = {
                    ...config,
                };
                return method(url, finalConfig);
            };
        };

        return {
            get: injectContextForNoDataMethods(api.get),
            post: injectContextForDataMethods(api.post),
            put: injectContextForDataMethods(api.put),
            delete: injectContextForNoDataMethods(api.delete),
        };
    }, []);

    return apiWithContext;
};

export default useApi;

